import { Component, Input, ViewEncapsulation } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TablerIconComponent } from '@ukam/ui-kit/icon/tabler-icon.component';
import { SearchService } from '@ukam/core/services/search.service';

@Component({
    selector: 'app-search-pagination',
    templateUrl: './search-pagination.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports: [ MatButtonModule, MatIconModule, TablerIconComponent]
})
export class AppSearchPaginationComponent {
    @Input({ required: true }) searchService!: SearchService<any>;
}
